import { IHelpCenterArticleGeneric } from '@/interfaces';

/**
 * Generate a slug from a help center article by converting the English title to lowercase kebab-case
 * Removes special characters that would cause URL issues
 */
export function getHelpCenterArticleSlug(
  article: IHelpCenterArticleGeneric
): string {
  return article.help_center_article_title_en
    .toLowerCase()
    .replace(/[?!'".,;:()[\]{}\/\\&@#$%^*+=<>|~`＆–—]/g, '') // Remove special characters (including full-width ＆ and en/em dashes)
    .replace(/\s+/g, '-') // Replace spaces with hyphens
    .replace(/-+/g, '-') // Collapse multiple hyphens
    .replace(/^-|-$/g, ''); // Remove leading/trailing hyphens
}

/**
 * Split a comma-separated help article tag string into trimmed tags.
 * Handles both half-width (,) and full-width (，) commas; returns [] for null.
 */
export function splitHelpTags(tags?: string | null): string[] {
  if (!tags) return [];
  return tags
    .split(/[,，]/)
    .map(tag => tag.trim())
    .filter(tag => tag.length > 0);
}

/**
 * Generate a URL slug from a help center category English name,
 * e.g. "Passes & Payments" → "passes-payments"
 */
export function getHelpCategorySlug(categoryNameEn: string): string {
  return categoryNameEn
    .toLowerCase()
    .replace(/[?!'".,;:()[\]{}\/\\&@#$%^*+=<>|~`＆–—]/g, '')
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '');
}
